import React from 'react';
import PropTypes from 'prop-types';

const NotificationStatus = (props) => {
  return props.isSent ? (
    <button type="button" className="btn sentBtn">
      Sent
    </button>
  ) : null;
};

NotificationStatus.propTypes = {
  isSent: PropTypes.bool,
};

export default NotificationStatus;
